export default {
  label: 'Agents',
  placeholder: 'No agent',
  indifferent: 'Indifferent',
  other: 'other',
  others: 'others',
};
